<template>
  <d-card>
    <template v-if="internalApplicants.length">
      <d-card-row
        v-for="(applicant, key) in internalApplicants"
        :key="key"
      >
        <div class="columns">
          <div class="column">
            <v-input
              :value="applicant.first_name"
              required
              :name="'applicants.'+ key +'.first_name'"
              :class="{ 'is-danger': hasError(key, 'first_name') }"
              :label="$t('first_name')"
              :placeholder="$t('first_name')"
              @input="update('first_name', $event, key)"
            />
          </div>
          <div class="column">
            <v-input
              :value="applicant.last_name"
              required
              :name="'applicants.'+ key +'.last_name'"
              :class="{ 'is-danger': hasError(key, 'last_name')}"
              :label="$t('last_name')"
              :placeholder="$t('last_name')"
              @input="update('last_name', $event, key)"
            />
          </div>
        </div>

        <div class="mb-5">
          <v-input
            :value="applicant.email"
            required
            :name="'applicants.'+ key +'.email'"
            :class="{ 'is-danger': hasError(key, 'email')}"
            :label="$t('email')"
            :placeholder="$t('email')"
            @input="update('email', $event, key)"
          />
        </div>
        <div class="mb-5">
          <v-input-select
            :value="applicant.applicant_type"
            :name="'applicants.'+ key +'.applicant_type'"
            :label="$t('applicant_type')"
            :class="{ 'is-danger': hasError(key, 'applicant_type')}"
            required
            @input="update('applicant_type', $event, key)"
          >
            <option :value="null">
              {{ $t("select").capitalize() }}
            </option>
            <option
              v-for="(type, key) in $laravel.applicantTypesEnum"
              :key="key"
              :value="type.value"
            >
              {{ type.label }}
            </option>
          </v-input-select>
        </div>

        <div class="mb-2">
          <v-input-select
            :value="applicant.locale"
            :name="'applicants.'+ key +'.locale'"
            :class="{ 'is-danger': hasError(key, 'locale')}"
            required
            @input="update('locale', $event, key)"
          >
            <option :value="null">
              {{ $t("select").capitalize() }}
            </option>
            <option
              v-for="(locale, code) in $laravel.app.locales"
              :key="code"
              :value="code"
            >
              {{ locale }}
            </option>
          </v-input-select>
        </div>
        <div class="mt-2 mb-2">
          <button
            v-if="internalApplicants.length > 1"
            class="button is-white is-small is-underline"
            type="button"
            @click="remove(key)"
          >
            {{ $t('remove_applicant') }}
          </button>
        </div>
      </d-card-row>
    </template>
    <d-card-row>
      <button
        class="button is-small"
        type="button"
        @click="add"
      >
        {{ $t('add_applicant') }}
      </button>
    </d-card-row>
  </d-card>
</template>
<script>

export default {
  props: {
    applicants: {
      default() {
        return [];
      },
      type: Array
    },
    errors: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  data() {
    return {
      internalApplicants: this.applicants || []
    };
  },
  methods: {
    hasError(index, key) {
      const error = _.get(this.errors, "applicants." + index + "."+ key , null);
      return error && error[0] ? error[0] : false;
    },
    update(field, value, key) {
      let applicants = _.cloneDeep(this.internalApplicants);
      applicants[key][field] = value;
      this.internalApplicants = applicants;
      this.$emit("update", applicants);
    },
    add() {
      let applicants = _.cloneDeep(this.internalApplicants);
      applicants.push({
        first_name: null,
        last_name: null,
        email: null,
        applicant_type: null,
        locale: null,
      });
      this.internalApplicants = applicants;
      this.$emit("update", applicants);
    },
    remove(key) {
      let applicants = _.cloneDeep(this.internalApplicants);
      applicants.splice(key, 1);
      this.internalApplicants = applicants;
      this.$emit("update", applicants);
    }
  },

};
</script>
